import React from "react";

import heroImg from "../../images/icon/semi.c1b08476baac09b2e722.gif";

import "./CompanyOverview.css";

type OverviewFeature = {
  title: string;
  description: string;
  icon: "focus" | "capable" | "dependable" | "collaborative";
};

const overviewFeatures: OverviewFeature[] = [
  {
    title: "Focused",
    description: "Semiconductor engineering is at the core of what we do.",
    icon: "focus",
  },
  {
    title: "Capable",
    description: "Deep technical expertise across the silicon lifecycle.",
    icon: "capable",
  },
  {
    title: "Dependable",
    description: "Accountable delivery with quality and confidentiality.",
    icon: "dependable",
  },
  {
    title: "Collaborative",
    description: "We work as an extension of your team.",
    icon: "collaborative",
  },
];

const OverviewIcon: React.FC<{
  icon: OverviewFeature["icon"];
}> = ({ icon }) => {
  const commonProps = {
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
  };

  if (icon === "focus") {
    return (
      <svg {...commonProps}>
        <circle cx="24" cy="24" r="16" />
        <circle cx="24" cy="24" r="9" />
        <circle cx="24" cy="24" r="3" />
        <path d="M31 17 40 8" />
        <path d="M35 8h5v5" />
      </svg>
    );
  }

  if (icon === "capable") {
    return (
      <svg {...commonProps}>
        <circle cx="18" cy="18" r="6" />
        <circle cx="31" cy="18" r="6" />
        <path d="M7 38c1-8 6-12 12-12s11 4 12 12" />
        <path d="M24 38c1-8 5-12 11-12s10 4 11 12" />
      </svg>
    );
  }

  if (icon === "dependable") {
    return (
      <svg {...commonProps}>
        <path d="M24 5 39 11v11c0 10-6 17-15 21C15 39 9 32 9 22V11l15-6Z" />
        <path d="m18 24 4 4 8-9" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <path d="M14 25 7 18l7-7 7 7" />
      <path d="m34 25 7-7-7-7-7 7" />
      <path d="m14 25 7 7c2 2 5 2 7 0l6-7" />
      <path d="m21 18 3-3c2-2 5-2 7 0l3 3" />
      <path d="m17 28 4 4" />
      <path d="m22 31 3 3" />
    </svg>
  );
};

const CompanyOverview: React.FC = () => {
  return (
    <section
      className="company-overview-section"
      id="company-overview"
    >
      <div className="company-overview-wrap">
        <div className="company-overview-grid-bg" />

        <div className="company-overview-container">
          <div className="company-overview-main">

            {/* LEFT CONTENT */}
            <div className="company-overview-content">
              <div className="company-overview-eyebrow">
                <span className="company-overview-eyebrow-square" />
                <span>COMPANY OVERVIEW</span>
              </div>

              <div className="company-overview-eyebrow-line" />

              <h2 className="company-overview-title">
                About
                <span>Digicomm</span>
              </h2>

              <div className="company-overview-title-line">
                <span />
                <i />
              </div>

              <p className="company-overview-description">
                Digicomm Semiconductor is a specialized semiconductor
                engineering organization supporting semiconductor companies
                across the complete silicon development lifecycle.
              </p>

              <p className="company-overview-description">
                With expertise spanning core semiconductor engineering
                disciplines, complemented by specialized engineering
                capabilities and flexible engagement models, we help transform
                complex engineering requirements into reliable silicon outcomes
                through disciplined execution, technical excellence, and
                collaborative engineering.
              </p>
            </div>

            {/* RIGHT VISUAL */}
            <div className="company-overview-visual">





              <div className="company-overview-image">
                <img
                  src={heroImg}
                  alt="Digicomm semiconductor engineering"
                />
              </div>
            </div>
          </div>

          {/* BOTTOM FEATURE STRIP */}
          <div className="company-overview-features">
            {overviewFeatures.map((feature) => (
              <article
                className="company-overview-feature"
                key={feature.title}
              >
                <div className="company-overview-feature-icon">
                  <OverviewIcon icon={feature.icon} />
                </div>

                <div className="company-overview-feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;